import ProcessIMG1 from  '../../../assets/images/nas-process-1.png'
import ProcessIMG2 from  '../../../assets/images/nas-process-2.png'
import ProcessIMG3 from  '../../../assets/images/nas-process-3.png'
import ProcessIMG4 from  '../../../assets/images/nas-process-4.png'
import ProcessIMG5 from  '../../../assets/images/nas-process-5.png'
import ProcessMobile1 from '../../../assets/images/itm01.png';
import ProcessMobile2 from '../../../assets/images/itm02.png';
import ProcessMobile3 from '../../../assets/images/itm03.png';
import ProcessMobile4 from '../../../assets/images/itm04.png';
import ProcessMobile5 from '../../../assets/images/itm05.png';
import ProcessMobile6 from '../../../assets/images/itm05.png';

import { Service } from './types';

export const services: Service[] = [
  {
    id: 1,
    icon: ProcessMobile1,
    mobileIcon: ProcessMobile1,
    alt: 'IT Monleys NAS Synology',
    title: 'Audit et diagnostic',
    description: 'Audit approfondi de votre infrastructure actuelle.',
    link: '/#',
    features: [
      { text: '' },
      { text: "Évaluation globale." },
      { text: 'Identification des points faibles.' },
      { text: 'Priorisation des besoins.' },
    ],
  },
  {
    id: 2,
    icon: ProcessMobile2,
    mobileIcon: ProcessMobile2,
    alt: 'Cybersecurity Icon',
    title: 'Définition d’une stratégie',
    description: 'Élaboration d’une stratégie de migration alignée sur vos enjeux.',
    link: '/#',
    features: [
      { text: '' },
      { text: 'Objectifs clairs.' },
      { text: 'Plan d’action sur-mesure.' },
      { text: 'Alignement avec les enjeux.' },
    ],
  },
  {
    id: 3,
    icon: ProcessMobile3,
    mobileIcon: ProcessMobile3,
    alt: 'Cloud Service Icon',
    title: 'Conception de l’architecture',
    description: 'Conception d’une architecture cloud évolutive et sécurisée.',
    link: '/#',
    features: [
      { text: '' },
      { text: "Choix technologiques optimaux." },
      { text: 'Scalabilité intégrée' },
      { text: 'Sécurité renforcée.' }
    ],
  },
  {
    id: 4,
    icon: ProcessMobile4,
    mobileIcon: ProcessMobile4,
    alt: 'OpenAI Icon',
    title: 'Exécution de la migration',
    description: 'Migration de votre infrastructure dans le respect des standards de sécurité les plus stricts.',
    link: '/#',
    features: [
      { text: '' },
      { text: 'Migration progressive.' },
      { text: 'Minimisation des risques.' },
      { text: 'Suivi en temps réel.' },

    ],
  },
  {
    id: 5,
    icon: ProcessMobile5,
    mobileIcon: ProcessMobile5,
    alt: 'Training Icon',
    title: 'Post-migration',
    description: 'Accompagnement dans l\'adaptation de vos ressources, réduction de vos coûts et renforcement de votre sécurité.',
    link: '/training',
    features: [
      { text: '' },
      { text: 'Support continu.' },
      { text: 'Optimisation des ressources.' },
      { text: 'Adaptabilité aux évolutions.' },
    ],
  },
  {
    id: 6,
    icon: ProcessMobile6,
    mobileIcon: ProcessMobile6,
    alt: 'Optimization Icon',
    title: 'Optimisation continue',
    description: 'Amélioration constante de votre infrastructure cloud pour maximiser les performances et réduire les coûts.',
    link: '/#',
    features: [
      { text: '' },
      { text: 'Monitoring proactif.' },
      { text: 'Ajustements en temps réel.' },
      { text: 'ROI optimisé.' },
    ],
  },
];
